import { Slice } from "./activeStateSlice";

const { actions } = Slice;

export const setstateCartable = (queryParams: any) => (
  dispatch: (arg0: { payload: any; type: string }) => void
) => {
  // dispatch(actions.startCall({ callType: callTypes.list }));
  return dispatch(actions.stateCartableSet(queryParams));
};
